import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable'
import flvwLogo from './flvw_logo'
import User from '@/classes/User/user';
import { collection, getDocs, getFirestore, updateDoc } from 'firebase/firestore';
import Reisekostenabrechnung from '../reisekostenabrechnung_v2';
const { PDFDocument } = require('pdf-lib');


export default class PDF_Generator {
    constructor(
        name,
        abrechnung,
        user = null
    ) {
        this.doc = new jsPDF();
        this.name = name || 'abrechnung'
        this.abrechnung = Array.isArray(abrechnung) ? abrechnung[0] : abrechnung
        this.abrechnungen = Array.isArray(abrechnung) ? abrechnung : [abrechnung]
        this.PageNumber = 1
        this.PageCount = 1
        this.pos = {
            y: 10,
            x: 10
        }
        this.pdfBelege = []
        this.pdf = ''
        this.user = user

        this.failed = []

        this.kostenarten = []
        this.pauschalenarten = []
    }

    addPDF() {
        this.doc.addPage()
        this.PageNumber++
        this.PageCount = 1
        this.pos = {
            y: 10,
            x: 10
        }
    }

    save() {
        this.doc.save(this.name + '.pdf');
    }

    formatIBAN(iban) {
        return iban.match(/.{1,4}/g)?.join(' ')
    }

    async generatePDF(simulate = false) {
        this.pdf = await PDFDocument.create();
        for (const abrechnung of this.abrechnungen) {
            try {
                if (this.user instanceof User && (this.user.finanzen() || this.user.kk())) {
                    abrechnung.printed = true
                    if (abrechnung.status == 'Genehmigt') {
                        abrechnung.abschliessen(this.user, false)
                    }
                    else {
                        await updateDoc(abrechnung.ref, abrechnung.toFirestore())
                    }
                }

                this.doc = new jsPDF();
                this.PageNumber = 1;
                this.PageCount = 1;
                this.pos = {
                    y: 10,
                    x: 10
                };
                this.abrechnung = abrechnung;
                abrechnung.errors = []
                this.person = this.abrechnung.abrechnender;
                if (this.abrechnungen.length == 1) {
                    this.name = 'FLVW-' + abrechnung.type + '-' + this.person.nachname + '-' + Date.now()
                }

                if (this.abrechnung?.type == 'Auslagenabrechnung') {
                    if (this.abrechnung.v2) {
                        await getDocs(collection(getFirestore(), 'Kostenarten')).then(kostenartenDocs => {
                            this.kostenarten = []
                            kostenartenDocs.forEach(ka => {
                                this.kostenarten.push({
                                    id: ka.id,
                                    name: ka.data().name,
                                    icon: ka.data().icon
                                })
                            })
                        }).then(async () => {
                            await getDocs(collection(getFirestore(), 'Pauschalenarten')).then(pauschalenartenDocs => {
                                this.pauschalenarten = []
                                pauschalenartenDocs.forEach(pa => {
                                    this.pauschalenarten.push({
                                        id: pa.id,
                                        name: pa.data().name,
                                        icon: pa.data().icon
                                    })
                                })
                            }).then(async () => {
                                return this.auslagenabrechnung_v2();
                            })
                        })
                    }
                    else {
                        const auslagenabrechnung = await this.auslagenabrechnung();
                    }
                }
                else {
                    if (this.abrechnung.v2) {
                        await getDocs(collection(getFirestore(), 'Kostenarten')).then(kostenartenDocs => {
                            this.kostenarten = []
                            kostenartenDocs.forEach(ka => {
                                this.kostenarten.push({
                                    id: ka.id,
                                    name: ka.data().name,
                                    icon: ka.data().icon
                                })
                            })
                        }).then(async () => {
                            await getDocs(collection(getFirestore(), 'Pauschalenarten')).then(pauschalenartenDocs => {
                                this.pauschalenarten = []
                                pauschalenartenDocs.forEach(pa => {
                                    this.pauschalenarten.push({
                                        id: pa.id,
                                        name: pa.data().name,
                                        icon: pa.data().icon
                                    })
                                })
                            }).then(async () => {
                                return this.reisekostenabrechnung_v2();
                            })
                        })
                    }
                    else {
                        const reisekostenabrechnung = await this.reisekostenabrechnung();
                    }
                }

                const abrechnungPdfDoc = await PDFDocument.load(this.doc.output('dataurlstring'));
                const abrechnungPdfPages = await this.pdf.copyPages(abrechnungPdfDoc, abrechnungPdfDoc.getPageIndices());
                abrechnungPdfPages.forEach(page => {
                    this.pdf.addPage(page);
                })

                for (const pdfFile of this.pdfBelege) {
                    // Load each PDF file
                    const pdfBytes = await fetch(pdfFile).then((response) => response.arrayBuffer());

                    // Add each PDF file to the merged PDF document
                    const pdfDoc = await PDFDocument.load(pdfBytes);
                    const pages = await this.pdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                    pages.forEach((page) => {
                        this.pdf.addPage(page);
                    });
                }

                if (this.user instanceof User && (this.user.finanzen() || this.user.kk())) {
                    if (abrechnung.status == 'Abgeschlossen') {
                        abrechnung.SendeBenachrichtigungen(['user-notification'])
                    }
                }
            } catch (error) {
                abrechnung.errors.push(error)
                this.failed.push(abrechnung)

                abrechnung.freigaben = abrechnung.freigaben.filter(freigabe => !freigabe.message.includes('abgeschlossen'));
                abrechnung.historie = abrechnung.historie.filter(freigabe => !freigabe.message.includes('abgeschlossen'));
                if (abrechnung.status == 'Abgeschlossen') {
                    abrechnung.status = 'Genehmigt'
                }
                abrechnung.printed = false
                await updateDoc(abrechnung.ref, abrechnung.toFirestore())
            }
        }

        try {
            // Serialize the merged PDF to a Uint8Array
            const mergedPdfBytes = await this.pdf.save();
            // Create a Blob from the Uint8Array
            const mergedPdfBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' });

            if (!simulate) {
                // Create a download link
                const downloadLink = document.createElement('a');
                downloadLink.href = URL.createObjectURL(mergedPdfBlob);
                downloadLink.download = this.name + '.pdf'; // Specify the desired filename
                downloadLink.style.display = 'none';

                // Trigger the download
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }

            return {
                pdf: mergedPdfBytes,
                failed: this.failed
            }

        } catch (error) {
            abrechnung.errors.push(error)
            this.failed.push(abrechnung)

            return {
                pdf: null,
                failed: this.failed
            }
        }
    }

    async auslagenabrechnung() {
        // Don't forget, that there are CORS-Restrictions. So if you want to run it without a Server in your Browser you need to transform the image to a dataURL
        // Use http://dataurl.net/#dataurlmaker
        const person = this.abrechnung.abrechnender;

        this.doc.addImage(flvwLogo, "PNG", 15, 8, 20, 20, "FLVW Logo", "NONE", 0);

        this.doc.setFontSize(16);
        this.doc.setFont("helvetica", "normal", "bold");
        this.doc.text(this.abrechnung.type, 40, 17);
        this.doc.setFontSize(14);
        this.doc.setFont("helvetica", "normal", "normal");
        this.doc.text(this.abrechnung.zeitraum?.value?.name, 40, 22);

        this.doc.setFontSize(10);

        var tableInfoData = [['Kostenstelle', 'Kostenträger']];
        if (this.abrechnung.kostenstelle.length > 0 || this.abrechnung.kostentraeger.length > 0) {
            var length = this.abrechnung.kostenstelle.length >= this.abrechnung.kostentraeger.length ? this.abrechnung.kostenstelle.length : this.abrechnung.kostentraeger.length;
            for (var i = 0; i < length; i++) {
                const kostenstelle = this.abrechnung.kostenstelle.length - 1 >= i ? this.abrechnung.kostenstelle[i] : ''
                const kostentraeger = this.abrechnung.kostentraeger.length - 1 >= i ? this.abrechnung.kostentraeger[i] : ''
                tableInfoData.push([kostenstelle?.id, kostentraeger?.id])
            }
        }

        if (tableInfoData.length > 1) {
            autoTable(this.doc, {
                startY: 10,
                margin: { left: 122 },
                styles: {
                    lineWidth: 0.5,
                    lineColor: '#ccc',
                    fontSize: 9,
                    cellPadding: 1
                },
                tableWidth: 'auto',
                head: [], // Header row
                body: tableInfoData, // Data rows,
                didParseCell: (data) => {
                    const rowIndex = data.row.index;
                    const colIndex = data.column.index;
                    data.cell.styles.textColor = [0, 0, 0];

                    if (rowIndex === 0) {
                        data.cell.styles.fontStyle = 'bold';
                        data.cell.styles.halign = 'center';
                    } else {
                        data.cell.styles.fontStyle = 'normal';
                        data.cell.styles.halign = 'center';
                    }
                },
                didDrawPage: (data) => {
                    this.pos.y = parseInt(data.cursor.y) + 10;
                    this.pos.y < 30 ? this.pos.y = 30 : this.pos.y = this.pos.y + 0
                }
            });
        }
        else {
            this.pos.y = 30
        }

        /**
         * Abrechnung Summe Übersicht
         */

        var PosYKst = 0;

        var tableSumData = [
            [
                { content: 'Kostenübersicht', colSpan: 2, styles: { halign: 'center', valign: 'middle', fontStyle: 'bold', fontSize: 12, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: 'Fahrtkosten', styles: { halign: 'left', valign: 'middle', textColor: '#000000', fontStyle: 'bold' } },
                { content: this.abrechnung.fahrtkostensumme() + ' €', styles: { halign: 'right', valign: 'middle', textColor: '#000000' } }
            ],
            [
                { content: 'Tagegelder', styles: { halign: 'left', valign: 'middle', textColor: '#000000', fontStyle: 'bold' } },
                { content: this.abrechnung.tagegeldersumme() + ' €', styles: { halign: 'right', valign: 'middle', textColor: '#000000' } }
            ],
            [
                { content: 'Portokosten', styles: { halign: 'left', valign: 'middle', textColor: '#000000', fontStyle: 'bold' } },
                { content: this.abrechnung.portokostensumme() + ' €', styles: { halign: 'right', valign: 'middle', textColor: '#000000' } }
            ],
            [
                { content: 'Telefonkosten', styles: { halign: 'left', valign: 'middle', textColor: '#000000', fontStyle: 'bold' } },
                { content: this.abrechnung.telefonkostensumme() + ' €', styles: { halign: 'right', valign: 'middle', textColor: '#000000' } }
            ],
            [
                { content: 'Sonstige Kosten', styles: { halign: 'left', valign: 'middle', textColor: '#000000', fontStyle: 'bold' } },
                { content: this.abrechnung.sonstigekostensumme() + ' €', styles: { halign: 'right', valign: 'middle', textColor: '#000000' } }
            ],
            [
                { content: 'Gesamtsumme', styles: { halign: 'left', valign: 'middle', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff', fontStyle: 'bold' } },
                { content: this.abrechnung.gesamtsumme() + ' €', styles: { halign: 'right', valign: 'middle', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff', fontStyle: 'bold' } }
            ],
        ];

        autoTable(this.doc, {
            startY: this.pos.y,
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
                cellPadding: 3
            },
            tableWidth: 80,
            head: [], // Header row
            body: tableSumData, // Data rows
            didDrawPage: (data) => {
                PosYKst = parseInt(data.cursor.y);
            }
        });



        /**
         * Infos über Abrechnenden
         */

        // Funktionen
        var funktionen = ''
        person.funktionen.forEach((item, index) => {
            funktionen += item.funktion
            if (index + 1 < person.funktionen.length) {
                funktionen += ', '
            }
        })

        const abrechnenderData = [
            [
                { content: 'Abrechnender', colSpan: 2, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 12, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: `Funktionen`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${funktionen}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Name`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.vorname} ${person.nachname}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } }
            ],
            [
                { content: `Adresse`, styles: { halign: 'left', valign: 'top', fontStyle: 'bold' } },
                { content: `${person.adresse.strasse} ${person.adresse.nr},\n${person.adresse.plz} ${person.adresse.ort}`, styles: { halign: 'left', valign: 'top' } }
            ],
            [
                { content: person.bank_last_changed == 'Unverändert' ? 'Bankverbindung unverändert' : `Bankverbindung zuletzt geändert am ${person.bank_last_changed ? this.abrechnung.parseDatum(person.bank_last_changed) : ''}`, colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
            ],
            [
                { content: `IBAN`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person?.bank?.iban ? this.formatIBAN(person.bank.iban) : ''}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `BIC`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.bank.bic}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Kreditorennr`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', overflow: 'ellipsize' } },
                { content: `${this.abrechnung.kreditorennummer}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `KFZ-Kennzeichen`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.kfz_kennzeichen}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
        ];

        autoTable(this.doc, {
            startY: this.pos.y,
            margin: { left: 102 },
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
            },
            tableWidth: 'auto',
            head: [], // Header row
            body: abrechnenderData,
            didParseCell: (data) => {
                const rowIndex = data.row.index;
                const colIndex = data.column.index;
                data.cell.styles.textColor = [0, 0, 0];
            },
            didDrawPage: (data) => {
                this.pos.y = PosYKst > data.cursor.y ? PosYKst + 10 : parseInt(data.cursor.y) + 10;
            }
        });

        // Reisekosten Details

        const reisekostenDataHead = [
            [
                { content: 'Reisekosten', colSpan: 5, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 14, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: `Veranstaltung`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `Route`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `Fahrtkosten`, styles: { halign: 'center', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `Tagegeld`, styles: { halign: 'center', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `Summe`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
            ],
        ];
        const reisekostenData = []
        this.abrechnung.reisekosten.forEach(fahrt => {
            const rowspan = fahrt.kostenstelle || fahrt.kostentraeger ? 2 : 1
            reisekostenData.push([
                {
                    content: fahrt.mehrtaegig ? `Von ${fahrt.parseDatum()} - ${fahrt.tagegeld.get_abwesend_von()}
Bis ${fahrt.bis_datum ? fahrt.parseBisDatum() : fahrt.parseDatum()} - ${fahrt.tagegeld.get_abwesend_bis()}
${fahrt.veranstaltung}` : `${fahrt.parseDatum()}\n${fahrt.tagegeld.get_abwesend_von()} - ${fahrt.tagegeld.get_abwesend_bis()}\n${fahrt.veranstaltung}${fahrt.kostenstelle ? '\n\nKostenstelle: ' + fahrt.kostenstelle?.id + (fahrt.kostentraeger ? '\n' : '') : ''}${fahrt.kostentraeger ? 'Kostenträger: ' + fahrt.kostentraeger.id : ''}`,
                    styles: {
                        halign: 'left',
                        valign: 'middle',
                        fontStyle: 'normal',
                        textColor: '#000000'
                    }
                },
                {
                    content: this.getRouteString(fahrt),
                    styles: {
                        halign: 'left',
                        valign: 'middle',
                        fontStyle: 'normal',
                        textColor: '#000000'
                    }
                },
                {
                    content: `${fahrt.get_fahrtkosten()} €`,
                    styles: {
                        halign: 'center',
                        valign: 'middle',
                        fontStyle: 'normal',
                        textColor: '#000000'
                    }
                },
                {
                    content: `${fahrt.tagegeld.summe.toFixed(2)} €`,
                    styles: {
                        halign: 'center',
                        valign: 'middle',
                        fontStyle: 'normal',
                        textColor: '#000000'
                    }
                },
                {
                    content: `${fahrt.calculateSumme()} €`,
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        textColor: '#000000'
                    }
                },
            ])
        })

        reisekostenData.push([
            {
                content: `Gesamt:`,
                colSpan: 2,
                styles: {
                    halign: 'right',
                    valign: 'middle',
                    fontStyle: 'bold',
                    fontSize: 10,
                    fillColor: false,
                    lineColor: false,
                    textColor: '#000000'
                }
            },
            {
                content: `${this.abrechnung.fahrtkostensumme()} €`,
                styles: {
                    halign: 'center',
                    valign: 'middle',
                    fontStyle: 'normal',
                    fontSize: 10,
                    fillColor: false,
                    lineColor: false,
                    textColor: '#000000'
                }
            },
            {
                content: `${this.abrechnung.tagegeldersumme()} €`,
                styles: {
                    halign: 'center',
                    valign: 'middle',
                    fontStyle: 'normal',
                    fontSize: 10,
                    fillColor: false,
                    lineColor: false,
                    textColor: '#000000'
                }
            },
            {
                content: `${this.abrechnung.reisekostensumme()} €`,
                styles: {
                    halign: 'right',
                    valign: 'middle',
                    fontStyle: 'bold',
                    fontSize: 10,
                    fillColor: false,
                    lineColor: false,
                    textColor: '#000000'
                }
            }
        ])

        autoTable(this.doc, {
            startY: this.pos.y,
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
            },
            tableWidth: 'auto',
            head: reisekostenDataHead, // Header row
            body: reisekostenData,
            didDrawPage: (data) => {
                this.finishTablePage(data);
            }
        });

        this.checkPageBreak(200)

        // Portokosten Details

        const portokostenDataHead = [
            [
                { content: 'Portokosten', colSpan: 4, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 14, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: `Datum`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `Art`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `Empfänger`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `Kosten`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
            ],
        ];
        const portokostenData = []
        this.abrechnung.portokosten.forEach(porto => {
            portokostenData.push([
                {
                    content: this.abrechnung.parseDatum(porto.datum),
                    styles: {
                        halign: 'left',
                        valign: 'middle',
                        fontStyle: 'normal',
                        textColor: '#000000'
                    }
                },
                {
                    content: porto.art,
                    styles: {
                        halign: 'left',
                        valign: 'middle',
                        fontStyle: 'normal',
                        textColor: '#000000'
                    }
                },
                {
                    content: porto.empfaenger,
                    styles: {
                        halign: 'left',
                        valign: 'middle',
                        fontStyle: 'normal',
                        textColor: '#000000'
                    }
                },
                {
                    content: `${porto.kosten} €`,
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        textColor: '#000000'
                    }
                }
            ])
        })

        portokostenData.push([
            {
                content: `Portokosten Gesamt:   ${this.abrechnung.portokostensumme()} €`,
                colSpan: 4,
                styles: {
                    halign: 'right',
                    valign: 'middle',
                    fontStyle: 'bold',
                    fontSize: 10,
                    fillColor: false,
                    lineColor: false,
                    textColor: '#000000'
                }
            }
        ])
        if (portokostenData.length > 1) {
            autoTable(this.doc, {
                startY: this.pos.y,
                styles: {
                    lineWidth: 0.5,
                    lineColor: '#ccc',
                },
                tableWidth: 'auto',
                head: portokostenDataHead, // Header row
                body: portokostenData,
                didDrawPage: (data) => {
                    this.finishTablePage(data);
                }
            });
        }

        this.checkPageBreak(200)

        // Telefonkosten Details

        const telefonkostenDataHead = [
            [
                { content: 'Telefonkosten', colSpan: 3, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 14, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: `Datum/Zeitraum`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `Bezeichnung`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `Kosten`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
            ],
        ];

        const telefonkostenData = []
        this.abrechnung.telefonkosten.forEach(telefon => {
            telefonkostenData.push([
                {
                    content: telefon.type == 'Telefonpauschale' ? telefon.zeitraum : this.abrechnung.parseDatum(telefon.datum),
                    styles: {
                        halign: 'left',
                        valign: 'middle',
                        fontStyle: 'normal',
                        textColor: '#000000'
                    }
                },
                {
                    content: telefon.type == 'Telefonpauschale' ? telefon?.name : telefon.empfaenger,
                    styles: {
                        halign: 'left',
                        valign: 'middle',
                        fontStyle: 'normal',
                        textColor: '#000000'
                    }
                },
                {
                    content: telefon.kosten + ' €',
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        textColor: '#000000'
                    }
                }
            ])
        })

        telefonkostenData.push([
            {
                content: `Telefonkosten Gesamt:   ${this.abrechnung.telefonkostensumme()} €`,
                colSpan: 3,
                styles: {
                    halign: 'right',
                    valign: 'middle',
                    fontStyle: 'bold',
                    fontSize: 10,
                    fillColor: false,
                    lineColor: false,
                    textColor: '#000000'
                }
            }
        ])
        if (telefonkostenData.length > 1) {
            autoTable(this.doc, {
                startY: this.pos.y,
                styles: {
                    lineWidth: 0.5,
                    lineColor: '#ccc',
                },
                tableWidth: 'auto',
                head: telefonkostenDataHead, // Header row
                body: telefonkostenData,
                didDrawPage: (data) => {
                    this.finishTablePage(data);
                }
            });

            this.checkPageBreak(200)
        }

        // Sonstige Kosten Details

        const sonstigekostenDataHead = [
            [
                { content: 'Sonstige Kosten', colSpan: 3, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 14, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: `Datum`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `Beschreibung`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `Kosten`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
            ],
        ];

        const sonstigekostenData = []
        this.abrechnung.sonstige_kosten.forEach(kosten => {
            sonstigekostenData.push([
                {
                    content: this.abrechnung.parseDatum(kosten.datum),
                    styles: {
                        halign: 'left',
                        valign: 'middle',
                        fontStyle: 'normal',
                        textColor: '#000000'
                    }
                },
                {
                    content: kosten.beschreibung,
                    styles: {
                        halign: 'left',
                        valign: 'middle',
                        fontStyle: 'normal',
                        textColor: '#000000'
                    }
                },
                {
                    content: kosten.kosten + ' €',
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        textColor: '#000000'
                    }
                }
            ])
        })

        sonstigekostenData.push([
            {
                content: `Sonstige Kosten Gesamt:   ${this.abrechnung.sonstigekostensumme()} €`,
                colSpan: 3,
                styles: {
                    halign: 'right',
                    valign: 'middle',
                    fontStyle: 'bold',
                    fontSize: 10,
                    fillColor: false,
                    lineColor: false,
                    textColor: '#000000'
                }
            }
        ])

        if (sonstigekostenData.length > 1) {
            autoTable(this.doc, {
                startY: this.pos.y,
                styles: {
                    lineWidth: 0.5,
                    lineColor: '#ccc',
                },
                tableWidth: 'auto',
                head: sonstigekostenDataHead, // Header row
                body: sonstigekostenData,
                didDrawPage: (data) => {
                    this.finishTablePage(data);
                }
            });
        }

        this.printSignatures();

        this.printBelege()
    }

    async auslagenabrechnung_v2() {
        // Don't forget, that there are CORS-Restrictions. So if you want to run it without a Server in your Browser you need to transform the image to a dataURL
        // Use http://dataurl.net/#dataurlmaker
        const person = this.abrechnung.abrechnender;

        this.doc.addImage(flvwLogo, "PNG", 15, 8, 20, 20, "FLVW Logo", "NONE", 0);

        this.doc.setFontSize(16);
        this.doc.setFont("helvetica", "normal", "bold");
        this.doc.text(this.abrechnung.type, 40, 17);
        this.doc.setFontSize(14);
        this.doc.setFont("helvetica", "normal", "normal");
        this.doc.text(this.abrechnung.zeitraum.value.name, 40, 22);

        this.doc.setFontSize(10);

        var tableInfoData = [['Kostenstelle', 'Kostenträger']];
        if (this.abrechnung.kostenstelle.length > 0 || this.abrechnung.kostentraeger.length > 0) {
            var length = this.abrechnung.kostenstelle.length >= this.abrechnung.kostentraeger.length ? this.abrechnung.kostenstelle.length : this.abrechnung.kostentraeger.length;
            for (var i = 0; i < length; i++) {
                const kostenstelle = this.abrechnung.kostenstelle.length - 1 >= i ? this.abrechnung.kostenstelle[i] : ''
                const kostentraeger = this.abrechnung.kostentraeger.length - 1 >= i ? this.abrechnung.kostentraeger[i] : ''
                tableInfoData.push([kostenstelle?.id, kostentraeger?.id])
            }
        }

        if (tableInfoData.length > 1) {
            autoTable(this.doc, {
                startY: 10,
                margin: { left: 122 },
                styles: {
                    lineWidth: 0.5,
                    lineColor: '#ccc',
                    fontSize: 9,
                    cellPadding: 1
                },
                tableWidth: 'auto',
                head: [], // Header row
                body: tableInfoData, // Data rows,
                didParseCell: (data) => {
                    const rowIndex = data.row.index;
                    const colIndex = data.column.index;
                    data.cell.styles.textColor = [0, 0, 0];

                    if (rowIndex === 0) {
                        data.cell.styles.fontStyle = 'bold';
                        data.cell.styles.halign = 'center';
                    } else {
                        data.cell.styles.fontStyle = 'normal';
                        data.cell.styles.halign = 'center';
                    }
                },
                didDrawPage: (data) => {
                    this.pos.y = parseInt(data.cursor.y) + 10;
                    this.pos.y < 30 ? this.pos.y = 30 : this.pos.y = this.pos.y + 0
                }
            });
        }
        else {
            this.pos.y = 30
        }

        /**
         * Abrechnung Summe Übersicht
         */

        var PosYKst = 0;

        var tableSumData = [
            [
                { content: 'Kostenübersicht', colSpan: 2, styles: { halign: 'center', valign: 'middle', fontStyle: 'bold', fontSize: 12, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: 'Fahrtkosten', styles: { halign: 'left', valign: 'middle', textColor: '#000000', fontStyle: 'bold' } },
                { content: this.abrechnung.fahrtkostensumme() + ' €', styles: { halign: 'right', valign: 'middle', textColor: '#000000' } }
            ],
            [
                { content: 'Tagegelder', styles: { halign: 'left', valign: 'middle', textColor: '#000000', fontStyle: 'bold' } },
                { content: this.abrechnung.tagegeldersumme() + ' €', styles: { halign: 'right', valign: 'middle', textColor: '#000000' } }
            ],
        ];

        this.abrechnung.get_kostenarten().forEach(id => {
            const kostenart = this.kostenarten.find(k => k.id == id)
            if(!kostenart) return
            tableSumData.push([
                { content: kostenart?.name, styles: { halign: 'left', valign: 'middle', textColor: '#000000', fontStyle: 'bold' } },
                { content: this.abrechnung.get_kostenart_summe(kostenart?.id) + ' €', styles: { halign: 'right', valign: 'middle', textColor: '#000000' } }
            ])
        })

        this.abrechnung.get_pauschalenarten().forEach(id => {
            const pauschalenart = this.pauschalenarten.find(k => k.id == id)
            if(!pauschalenart) return
            tableSumData.push([
                { content: pauschalenart?.name, styles: { halign: 'left', valign: 'middle', textColor: '#000000', fontStyle: 'bold' } },
                { content: this.abrechnung.get_pauschalenart_summe(pauschalenart?.id) + ' €', styles: { halign: 'right', valign: 'middle', textColor: '#000000' } }
            ])
        })

        tableSumData.push([
            { content: 'Gesamtsumme', styles: { halign: 'left', valign: 'middle', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff', fontStyle: 'bold' } },
            { content: this.abrechnung.gesamtsumme() + ' €', styles: { halign: 'right', valign: 'middle', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff', fontStyle: 'bold' } }
        ])

        autoTable(this.doc, {
            startY: this.pos.y,
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
                cellPadding: 3
            },
            tableWidth: 80,
            head: [], // Header row
            body: tableSumData, // Data rows
            didDrawPage: (data) => {
                PosYKst = parseInt(data.cursor.y);
            }
        });



        /**
         * Infos über Abrechnenden
         */

        // Funktionen
        var funktionen = ''
        person.funktionen.forEach((item, index) => {
            funktionen += item.funktion
            if (index + 1 < person.funktionen.length) {
                funktionen += ', '
            }
        })

        const abrechnenderData = [
            [
                { content: 'Abrechnender', colSpan: 2, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 12, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: `Funktionen`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${funktionen}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Name`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.vorname} ${person.nachname}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } }
            ],
            [
                { content: `Adresse`, styles: { halign: 'left', valign: 'top', fontStyle: 'bold' } },
                { content: `${person.adresse.strasse} ${person.adresse.nr},\n${person.adresse.plz} ${person.adresse.ort}`, styles: { halign: 'left', valign: 'top' } }
            ],
            [
                { content: person.bank_last_changed == 'Unverändert' ? 'Bankverbindung unverändert' : `Bankverbindung zuletzt geändert am ${person.bank_last_changed ? this.abrechnung.parseDatum(person.bank_last_changed) : ''}`, colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
            ],
            [
                { content: `IBAN`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person?.bank?.iban ? this.formatIBAN(person.bank.iban) : ''}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `BIC`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.bank.bic}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Kreditorennr`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', overflow: 'ellipsize' } },
                { content: `${this.abrechnung.kreditorennummer}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `KFZ-Kennzeichen`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.kfz_kennzeichen}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
        ];

        autoTable(this.doc, {
            startY: this.pos.y,
            margin: { left: 102 },
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
            },
            tableWidth: 'auto',
            head: [], // Header row
            body: abrechnenderData,
            didParseCell: (data) => {
                const rowIndex = data.row.index;
                const colIndex = data.column.index;
                data.cell.styles.textColor = [0, 0, 0];
            },
            didDrawPage: (data) => {
                this.pos.y = PosYKst > data.cursor.y ? PosYKst + 10 : parseInt(data.cursor.y) + 10;
            }
        });

        // Reisekosten Details
        if (this.abrechnung.reisekosten.length > 0) {
            const reisekostenDataHead = [
                [
                    { content: 'Reisekosten', colSpan: 5, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 14, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
                ],
                [
                    { content: `Veranstaltung`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                    { content: `Route`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                    { content: `Fahrtkosten`, styles: { halign: 'center', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                    { content: `Tagegeld`, styles: { halign: 'center', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                    { content: `Summe`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                ],
            ];
            const reisekostenData = []
            this.abrechnung.reisekosten.forEach(fahrt => {
                const rowspan = fahrt.kostenstelle || fahrt.kostentraeger ? 2 : 1
                reisekostenData.push([
                    {
                        content: fahrt.mehrtaegig ? `Von ${fahrt.parseDatum()} - ${fahrt.tagegeld.get_abwesend_von()}
Bis ${fahrt.bis_datum ? fahrt.parseBisDatum() : fahrt.parseDatum()} - ${fahrt.tagegeld.get_abwesend_bis()}
${fahrt.veranstaltung}` : `${fahrt.parseDatum()}\n${fahrt.tagegeld.get_abwesend_von()} - ${fahrt.tagegeld.get_abwesend_bis()}\n${fahrt.veranstaltung}${fahrt.kostenstelle ? '\n\nKostenstelle: ' + fahrt.kostenstelle.id + (fahrt.kostentraeger ? '\n' : '') : ''}${fahrt.kostentraeger ? 'Kostenträger: ' + fahrt.kostentraeger.id : ''}`,
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            fontStyle: 'normal',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: this.getRouteString(fahrt),
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            fontStyle: 'normal',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: `${fahrt.get_fahrtkosten()} €`,
                        styles: {
                            halign: 'center',
                            valign: 'middle',
                            fontStyle: 'normal',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: `${fahrt.tagegeld.summe.toFixed(2)} €`,
                        styles: {
                            halign: 'center',
                            valign: 'middle',
                            fontStyle: 'normal',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: `${fahrt.calculateSumme()} €`,
                        styles: {
                            halign: 'right',
                            valign: 'middle',
                            fontStyle: 'bold',
                            textColor: '#000000'
                        }
                    },
                ])
            })

            reisekostenData.push([
                {
                    content: `Gesamt:`,
                    colSpan: 2,
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        fontSize: 10,
                        fillColor: false,
                        lineColor: false,
                        textColor: '#000000'
                    }
                },
                {
                    content: `${this.abrechnung.fahrtkostensumme()} €`,
                    styles: {
                        halign: 'center',
                        valign: 'middle',
                        fontStyle: 'normal',
                        fontSize: 10,
                        fillColor: false,
                        lineColor: false,
                        textColor: '#000000'
                    }
                },
                {
                    content: `${this.abrechnung.tagegeldersumme()} €`,
                    styles: {
                        halign: 'center',
                        valign: 'middle',
                        fontStyle: 'normal',
                        fontSize: 10,
                        fillColor: false,
                        lineColor: false,
                        textColor: '#000000'
                    }
                },
                {
                    content: `${this.abrechnung.reisekostensumme()} €`,
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        fontSize: 10,
                        fillColor: false,
                        lineColor: false,
                        textColor: '#000000'
                    }
                }
            ])

            autoTable(this.doc, {
                startY: this.pos.y,
                styles: {
                    lineWidth: 0.5,
                    lineColor: '#ccc',
                },
                tableWidth: 'auto',
                head: reisekostenDataHead, // Header row
                body: reisekostenData,
                didDrawPage: (data) => {
                    this.finishTablePage(data);
                }
            });

            this.checkPageBreak(200)
        }

        if (this.abrechnung.ausgaben.length > 0) {
            // Ausgaben Details grouped by Kostenarten
            const tableHead = [
                [
                    { content: `Ausgaben`, colSpan: 4, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 14, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }

                ],
                [
                    { content: `Datum`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                    { content: `Kostenart`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                    { content: `Beschreibung`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                    { content: `Kosten`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                ],
            ]


            const kostenData = []
            this.abrechnung.ausgaben.forEach(kosten => {
                const kostenart = this.kostenarten.find(k => k.id == kosten.kostenart)
                if(!kostenart) return
                kostenData.push([
                    {
                        content: this.abrechnung.parseDatum(kosten.datum),
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            fontStyle: 'normal',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: kostenart.name,
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            fontStyle: 'bold',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: `${kosten.name} ${kosten.lerneinheiten ? '(' + kosten.lerneinheiten + ' LE)' : ''}`,
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            fontStyle: 'normal',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: `${kosten.kosten} €`,
                        styles: {
                            halign: 'right',
                            valign: 'middle',
                            fontStyle: 'bold',
                            textColor: '#000000'
                        }
                    }
                ])
            })
            kostenData.push([
                {
                    content: `Gesamt:`,
                    colSpan: 3,
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        fontSize: 10,
                        fillColor: false,
                        lineColor: false,
                        textColor: '#000000'
                    }
                },
                {
                    content: `${this.abrechnung.ausgabensumme()} €`,
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        fontSize: 10,
                        fillColor: false,
                        lineColor: false,
                        textColor: '#000000'
                    }
                }
            ])
            if (kostenData.length > 1) {
                autoTable(this.doc, {
                    startY: this.pos.y,
                    styles: {
                        lineWidth: 0.5,
                        lineColor: '#ccc',
                    },
                    tableWidth: 'auto',
                    head: tableHead, // Header row
                    body: kostenData,
                    didDrawPage: (data) => {
                        this.finishTablePage(data);
                    }
                });
            }
            this.checkPageBreak(200)
        }

        if (this.abrechnung.pauschalen.length > 0) {
            // Ausgaben Details grouped by Kostenarten
            const tableHead = [
                [
                    { content: `Pauschalen`, colSpan: 4, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 14, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }

                ],
                [
                    { content: `Pauschalenart`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                    { content: `Monat`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                    { content: `Beschreibung`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                    { content: `Summe`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                ],
            ]


            const pauschalenData = []
            this.abrechnung.pauschalen.forEach(pauschale => {
                const pauschalenart = this.pauschalenarten.find(p => p.id == pauschale.pauschalenart)
                if(!pauschalenart) return
                pauschalenData.push([
                    {
                        content: pauschalenart.name,
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            fontStyle: 'bold',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: pauschale.monat ? pauschale.monat + ' ' + pauschale.jahr : this.parseDate(pauschale.datum) + ' | ' + pauschale.uhrzeit.start + ' - ' + pauschale.uhrzeit.ende,
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            fontStyle: 'normal',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: pauschale.name + (pauschale.bemerkung ? `\n${pauschale.bemerkung}` : ''),
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            fontStyle: 'normal',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: `${pauschale.summe} €`,
                        styles: {
                            halign: 'right',
                            valign: 'middle',
                            fontStyle: 'bold',
                            textColor: '#000000'
                        }
                    }
                ])
            })
            pauschalenData.push([
                {
                    content: `Gesamt:`,
                    colSpan: 3,
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        fontSize: 10,
                        fillColor: false,
                        lineColor: false,
                        textColor: '#000000'
                    }
                },
                {
                    content: `${this.abrechnung.pauschalensumme()} €`,
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        fontSize: 10,
                        fillColor: false,
                        lineColor: false,
                        textColor: '#000000'
                    }
                }
            ])
            if (pauschalenData.length > 1) {
                autoTable(this.doc, {
                    startY: this.pos.y,
                    styles: {
                        lineWidth: 0.5,
                        lineColor: '#ccc',
                    },
                    tableWidth: 'auto',
                    head: tableHead, // Header row
                    body: pauschalenData,
                    didDrawPage: (data) => {
                        this.finishTablePage(data);
                    }
                });
            }
            this.checkPageBreak(200)
        }


        this.printSignatures();

        this.printBelege()
    }

    async reisekostenabrechnung() {
        // Don't forget, that there are CORS-Restrictions. So if you want to run it without a Server in your Browser you need to transform the image to a dataURL
        // Use http://dataurl.net/#dataurlmaker
        const person = this.abrechnung.abrechnender;

        this.doc.addImage(flvwLogo, "PNG", 15, 8, 20, 20, "FLVW Logo", "NONE", 0);

        this.doc.setFontSize(16);
        this.doc.setFont("helvetica", "normal", "bold");
        this.doc.text(this.abrechnung.type, 40, 17);
        this.doc.setFontSize(14);
        this.doc.setFont("helvetica", "normal", "normal");
        this.doc.text(this.abrechnung.reisezweck, 40, 22);

        this.doc.setFontSize(10);

        var tableInfoData = [['Kostenstelle', 'Kostenträger']];
        if (this.abrechnung.kostenstelle.length > 0 || this.abrechnung.kostentraeger.length > 0) {
            var length = this.abrechnung.kostenstelle.length >= this.abrechnung.kostentraeger.length ? this.abrechnung.kostenstelle.length : this.abrechnung.kostentraeger.length;
            for (var i = 0; i < length; i++) {
                const kostenstelle = this.abrechnung.kostenstelle.length - 1 >= i ? this.abrechnung.kostenstelle[i] : ''
                const kostentraeger = this.abrechnung.kostentraeger.length - 1 >= i ? this.abrechnung.kostentraeger[i] : ''
                tableInfoData.push([kostenstelle?.id, kostentraeger?.id])
            }
        }

        if (tableInfoData.length > 1) {
            autoTable(this.doc, {
                startY: 10,
                margin: { left: 122 },
                styles: {
                    lineWidth: 0.5,
                    lineColor: '#ccc',
                    fontSize: 9,
                    cellPadding: 1
                },
                tableWidth: 'auto',
                head: [], // Header row
                body: tableInfoData, // Data rows,
                didParseCell: (data) => {
                    const rowIndex = data.row.index;
                    const colIndex = data.column.index;
                    data.cell.styles.textColor = [0, 0, 0];

                    if (rowIndex === 0) {
                        data.cell.styles.fontStyle = 'bold';
                        data.cell.styles.halign = 'center';
                    } else {
                        data.cell.styles.fontStyle = 'normal';
                        data.cell.styles.halign = 'center';
                    }
                },
                didDrawPage: (data) => {
                    this.pos.y = parseInt(data.cursor.y) + 10;
                    this.pos.y < 30 ? this.pos.y = 30 : this.pos.y = this.pos.y + 0
                }
            });
        }
        else {
            this.pos.y = 30
        }

        /**
         * Infos über Reise
         */
        var PosYKst = 0;

        const reiseziel = this.abrechnung.routetype == 'Wegpunkte' ? this.reisekosten_wegpunkte() : this.abrechnung.reiseziel.getString()

        const reiseData = [
            [
                { content: 'Infos zur Reise', colSpan: 2, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 12, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: `Zweck der Reise`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${this.abrechnung.reisezweck}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Antritt der Reise`, styles: { halign: 'left', valign: 'top', fontStyle: 'bold' } },
                { content: `${this.parseDate(this.abrechnung.reisebeginn.datum)} um ${this.abrechnung.reisebeginn.uhrzeit}`, styles: { halign: 'left', valign: 'top' } }
            ],
            [
                { content: `Beendigung der Reise`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${this.parseDate(this.abrechnung.reiseende.datum)} um ${this.abrechnung.reiseende.uhrzeit}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Reisestart`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${this.abrechnung.reisestart.getString()}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Reiseziel`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${reiseziel}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
        ];

        autoTable(this.doc, {
            startY: this.pos.y,
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
            },
            tableWidth: 90,
            head: [], // Header row
            body: reiseData,
            didParseCell: (data) => {
                const rowIndex = data.row.index;
                const colIndex = data.column.index;
                data.cell.styles.textColor = [0, 0, 0];
            },
            didDrawPage: (data) => {
                PosYKst = parseInt(data.cursor.y);
            }
        });

        /**
         * Infos über Abrechnenden
         */

        // Funktionen
        var funktionen = ''
        person.funktionen.forEach((item, index) => {
            funktionen += item.funktion
            if (index + 1 < person.funktionen.length) {
                funktionen += ', '
            }
        })

        const abrechnenderData = [
            [
                { content: 'Abrechnender', colSpan: 2, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 12, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: `Funktionen`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${funktionen}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Name`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.vorname} ${person.nachname}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } }
            ],
            [
                { content: `Adresse`, styles: { halign: 'left', valign: 'top', fontStyle: 'bold' } },
                { content: `${person.adresse.strasse} ${person.adresse.nr},\n${person.adresse.plz} ${person.adresse.ort}`, styles: { halign: 'left', valign: 'top' } }
            ],
            [
                { content: person.bank_last_changed == 'Unverändert' ? 'Bankdaten unverändert' : `Bankdaten zuletzt geändert am ${person.bank_last_changed ? this.abrechnung.parseDatum(person.bank_last_changed) : ''}`, colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
            ],
            [
                { content: `IBAN`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.bank.iban ? this.formatIBAN(person.bank.iban) : ''}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `BIC`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.bank.bic}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ]
        ];

        if (this.abrechnung.kreditorennummer) {
            abrechnenderData.push([
                { content: `Kreditorennr`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', overflow: 'ellipsize' } },
                { content: `${this.abrechnung.kreditorennummer}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ])
        }

        autoTable(this.doc, {
            startY: this.pos.y,
            margin: { left: 110 },
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
            },
            tableWidth: 'auto',
            head: [], // Header row
            body: abrechnenderData,
            didParseCell: (data) => {
                const rowIndex = data.row.index;
                const colIndex = data.column.index;
                data.cell.styles.textColor = [0, 0, 0];
            },
            didDrawPage: (data) => {
                this.pos.y = PosYKst > data.cursor.y ? PosYKst + 10 : parseInt(data.cursor.y) + 10;
            }
        });

        /**
         * Kostenaufstellung
         */

        const kostenData = [
            [
                { content: 'Reisekosten', colSpan: 3, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 12, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ]
        ];
        kostenData.push(
            [
                { content: 'I. Auslagen:', colSpan: 3, styles: { halign: 'left', cellPadding: 3, valign: 'middle', fontStyle: 'bold', fillColor: '#dddddd', textColor: '#000000' } },
            ]
        );
        if (this.abrechnung.auslagen.active && this.abrechnung.auslagen.calculated.active) {
            const tag = this.abrechnung.auslagen.calculated.tage[0]
            kostenData.push([
                { content: `${this.parseDate(tag.datum)} - ${tag.dauer} Stunden - ${tag.getVerpflegung()} (${tag.calculate(this.abrechnung.auslagen.calculated.hauptmamt).toFixed(2)}€)`, colSpan: 2, styles: { halign: 'left', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                { content: `${this.abrechnung.auslagen.active ? this.abrechnung.auslagen.calculated.summe.toFixed(2) + '€' : ''}`, rowSpan: this.abrechnung.auslagen.calculated.tage.length, styles: { halign: 'right', valign: 'middle', cellPadding: 3, cellWidth: 30, fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } }
            ]);

            for (var j = 1; j < this.abrechnung.auslagen.calculated.tage.length; j++) {
                const t = this.abrechnung.auslagen.calculated.tage[j]
                kostenData.push([
                    { content: `${this.parseDate(t.datum)} - ${t.dauer} Stunden - ${t.getVerpflegung()} (${t.calculate(this.abrechnung.auslagen.calculated.hauptmamt).toFixed(2)}€)`, styles: { halign: 'left', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } }
                ])
            }
        }
        else {
            kostenData.push(
                [
                    { content: `${this.abrechnung.auslagen.tage} ${this.abrechnung.auslagen.tage == 1 ? 'Tag' : 'Tage'} je ${this.abrechnung.auslagen.satz.toFixed(2)}€`, colSpan: 2, styles: { halign: 'left', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${this.abrechnung.auslagen.active ? this.abrechnung.auslagen.summe + '€' : ''}`, styles: { halign: 'right', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } }
                ]
            );
        }
        kostenData.push(
            [
                { content: 'II. Fahrtkosten:', colSpan: 3, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#dddddd', textColor: '#000000' } },
            ]
        );
        if (this.abrechnung.fahrtkosten.bundesbahn.active) {
            kostenData.push(
                [
                    { content: this.abrechnung.fahrtkosten.bundesbahn.active ? `Bundesbahn (lt. Belege in der Anlage)` : '', colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${this.abrechnung.fahrtkosten.bundesbahn.active ? this.abrechnung.fahrtkosten.bundesbahn.summe + '€' : ''}`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                ]
            );
        }
        if (this.abrechnung.fahrtkosten.flugzeug.active) {
            kostenData.push(
                [
                    { content: `Flugzeug (lt. Belege in der Anlage)`, colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${this.abrechnung.fahrtkosten.flugzeug.active ? this.abrechnung.fahrtkosten.flugzeug.summe + '€' : ''}`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                ]
            );
        }
        if (this.abrechnung.fahrtkosten.zuschlaege.active) {
            kostenData.push(
                [
                    { content: `Zuschläge`, colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${this.abrechnung.fahrtkosten.zuschlaege.active ? this.abrechnung.fahrtkosten.zuschlaege.summe + '€' : ''}`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                ]
            );
        }
        if (this.abrechnung.fahrtkosten.pkw.active) {
            kostenData.push(
                [
                    { content: `PKW ${this.abrechnung.fahrtkosten.pkw.active ? `Kennzeichen: ${this.abrechnung.fahrtkosten.pkw.kennzeichen} - ${this.abrechnung.fahrtkosten.pkw.kilometer}km je 0.30€` : ''}`, colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${this.abrechnung.fahrtkosten.pkw.active ? this.abrechnung.fahrtkosten.pkw.summe + '€' : ''}`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                ]
            );
        }
        if (this.abrechnung.fahrtkosten.bus_taxi.active) {
            kostenData.push(
                [
                    { content: `Bus, Taxi, etc.`, colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${this.abrechnung.fahrtkosten.bus_taxi.active ? this.abrechnung.fahrtkosten.bus_taxi.summe + '€' : ''}`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                ]
            );
        }
        if (this.abrechnung.nebenkosten.length > 0) {
            kostenData.push(
                [
                    { content: 'III. Nebenkosten:', colSpan: 3, styles: { halign: 'left', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fillColor: '#dddddd', textColor: '#000000' } },
                ],
            );
        }
        this.abrechnung.nebenkosten.forEach((nebenkosten) => {
            kostenData.push(
                [
                    { content: nebenkosten.beschreibung, colSpan: 2, styles: { halign: 'left', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${parseFloat(nebenkosten.kosten).toFixed(2) + '€'}`, styles: { halign: 'right', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } }
                ]
            );
        });
        kostenData.push(
            [
                { content: 'Gesamtsumme:', colSpan: 2, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `${this.abrechnung.gesamtsumme() + '€'}`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } }
            ]
        );

        autoTable(this.doc, {
            startY: this.pos.y,
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
            },
            tableWidth: 'auto',
            head: [], // Header row
            body: kostenData,
            didDrawPage: (data) => {
                this.pos.y = parseInt(data.cursor.y) + 10;
            }
        });

        this.printSignatures();

        this.printBelege();

    }

    async reisekostenabrechnung_v2() {
        // Don't forget, that there are CORS-Restrictions. So if you want to run it without a Server in your Browser you need to transform the image to a dataURL
        // Use http://dataurl.net/#dataurlmaker
        const person = this.abrechnung.abrechnender;
        this.doc.addImage(flvwLogo, "PNG", 15, 8, 20, 20, "FLVW Logo", "NONE", 0);

        this.doc.setFontSize(16);
        this.doc.setFont("helvetica", "normal", "bold");
        this.doc.text(this.abrechnung.type, 40, 17);
        this.doc.setFontSize(14);
        this.doc.setFont("helvetica", "normal", "normal");
        this.doc.text(this.abrechnung.reisezweck, 40, 22);

        this.doc.setFontSize(10);

        var tableInfoData = [['Kostenstelle', 'Kostenträger']];
        if (this.abrechnung.kostenstelle.length > 0 || this.abrechnung.kostentraeger.length > 0) {
            var length = this.abrechnung.kostenstelle.length >= this.abrechnung.kostentraeger.length ? this.abrechnung.kostenstelle.length : this.abrechnung.kostentraeger.length;
            for (var i = 0; i < length; i++) {
                const kostenstelle = this.abrechnung.kostenstelle.length - 1 >= i ? this.abrechnung.kostenstelle[i] : ''
                const kostentraeger = this.abrechnung.kostentraeger.length - 1 >= i ? this.abrechnung.kostentraeger[i] : ''
                tableInfoData.push([kostenstelle?.id, kostentraeger?.id])
            }
        }

        if (tableInfoData.length > 1) {
            autoTable(this.doc, {
                startY: 10,
                margin: { left: 122 },
                styles: {
                    lineWidth: 0.5,
                    lineColor: '#ccc',
                    fontSize: 9,
                    cellPadding: 1
                },
                tableWidth: 'auto',
                head: [], // Header row
                body: tableInfoData, // Data rows,
                didParseCell: (data) => {
                    const rowIndex = data.row.index;
                    const colIndex = data.column.index;
                    data.cell.styles.textColor = [0, 0, 0];

                    if (rowIndex === 0) {
                        data.cell.styles.fontStyle = 'bold';
                        data.cell.styles.halign = 'center';
                    } else {
                        data.cell.styles.fontStyle = 'normal';
                        data.cell.styles.halign = 'center';
                    }
                },
                didDrawPage: (data) => {
                    this.pos.y = parseInt(data.cursor.y) + 10;
                    this.pos.y < 30 ? this.pos.y = 30 : this.pos.y = this.pos.y + 0
                }
            });
        }
        else {
            this.pos.y = 30
        }

        /**
         * Infos über Reise
         */
        var PosYKst = 0;

        const reiseziel = this.abrechnung.routetype == 'Wegpunkte' ? this.reisekosten_wegpunkte() : this.abrechnung.reiseziel.getString()

        const reiseData = [
            [
                { content: 'Infos zur Reise', colSpan: 2, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 12, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: `Zweck der Reise`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${this.abrechnung.reisezweck}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Antritt der Reise`, styles: { halign: 'left', valign: 'top', fontStyle: 'bold' } },
                { content: `${this.parseDate(this.abrechnung.reisebeginn.datum)} um ${this.abrechnung.reisebeginn.uhrzeit}`, styles: { halign: 'left', valign: 'top' } }
            ],
            [
                { content: `Beendigung der Reise`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${this.parseDate(this.abrechnung.reiseende.datum)} um ${this.abrechnung.reiseende.uhrzeit}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Reisestart`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${this.abrechnung.reisestart.getString()}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Reiseziel`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${reiseziel}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
        ];

        autoTable(this.doc, {
            startY: this.pos.y,
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
            },
            tableWidth: 90,
            head: [], // Header row
            body: reiseData,
            didParseCell: (data) => {
                const rowIndex = data.row.index;
                const colIndex = data.column.index;
                data.cell.styles.textColor = [0, 0, 0];
            },
            didDrawPage: (data) => {
                PosYKst = parseInt(data.cursor.y);
            }
        });

        /**
         * Infos über Abrechnenden
         */

        // Funktionen
        var funktionen = ''
        person.funktionen.forEach((item, index) => {
            funktionen += item.funktion
            if (index + 1 < person.funktionen.length) {
                funktionen += ', '
            }
        })

        const abrechnenderData = [
            [
                { content: 'Abrechnender', colSpan: 2, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 12, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ],
            [
                { content: `Funktionen`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${funktionen}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `Name`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.vorname} ${person.nachname}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } }
            ],
            [
                { content: `Adresse`, styles: { halign: 'left', valign: 'top', fontStyle: 'bold' } },
                { content: `${person.adresse.strasse} ${person.adresse.nr},\n${person.adresse.plz} ${person.adresse.ort}`, styles: { halign: 'left', valign: 'top' } }
            ],
            [
                { content: person.bank_last_changed == 'Unverändert' ? 'Bankdaten unverändert' : `Bankdaten zuletzt geändert am ${person.bank_last_changed ? this.abrechnung.parseDatum(person.bank_last_changed) : ''}`, colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
            ],
            [
                { content: `IBAN`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.bank.iban ? this.formatIBAN(person.bank.iban) : ''}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ],
            [
                { content: `BIC`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold' } },
                { content: `${person.bank.bic}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ]
        ];

        if (this.abrechnung.kreditorennummer) {
            abrechnenderData.push([
                { content: `Kreditorennr`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', overflow: 'ellipsize' } },
                { content: `${this.abrechnung.kreditorennummer}`, styles: { halign: 'left', valign: 'middle', fontStyle: 'normal' } }
            ])
        }

        autoTable(this.doc, {
            startY: this.pos.y,
            margin: { left: 110 },
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
            },
            tableWidth: 'auto',
            head: [], // Header row
            body: abrechnenderData,
            didParseCell: (data) => {
                const rowIndex = data.row.index;
                const colIndex = data.column.index;
                data.cell.styles.textColor = [0, 0, 0];
            },
            didDrawPage: (data) => {
                this.pos.y = PosYKst > data.cursor.y ? PosYKst + 5: parseInt(data.cursor.y) + 5;
            }
        });

        /**
         * Kostenaufstellung
         */

        const kostenData = [
            [
                { content: 'Reisekosten', colSpan: 3, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 12, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }
            ]
        ];
        kostenData.push(
            [
                { content: 'Tagegeld:', colSpan: 3, styles: { halign: 'left', cellPadding: 3, valign: 'middle', fontStyle: 'bold', fillColor: '#dddddd', textColor: '#000000' } },
            ]
        );
        if (this.abrechnung.auslagen.active && this.abrechnung.auslagen.calculated.active && this.abrechnung.auslagen.calculated.tage.length > 0) {
            for (var j = 0; j < this.abrechnung.auslagen.calculated.tage.length; j++) {
                const tag = this.abrechnung.auslagen.calculated.tage[j]
                kostenData.push([
                    { content: `${this.parseDate(tag.datum)} - ${tag.dauer} Stunden - ${tag.getVerpflegung()}`, colSpan: 2, styles: { halign: 'left', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${tag.calculate(this.abrechnung.auslagen.calculated.hauptmamt).toFixed(2) + ' €'}`, styles: { colWidth: 30, halign: 'right', valign: 'middle', cellWidth: 30, fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } }
                ])
            }
        }
        else {
            kostenData.push(
                [
                    { content: `${this.abrechnung.auslagen.tage} ${this.abrechnung.auslagen.tage == 1 ? 'Tag' : 'Tage'} je ${this.abrechnung.auslagen.satz.toFixed(2)}€`, colSpan: 2, styles: { halign: 'left', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${this.abrechnung.auslagen.active ? this.abrechnung.auslagen.summe + '€' : ''}`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } }
                ]
            );
        }
        kostenData.push([
            {
                content: `Summe:`,
                colSpan: 2,
                styles: {
                    halign: 'right',
                    valign: 'middle',
                    fontStyle: 'bold',
                    fontSize: 10,
                    fillColor: false,
                    lineColor: false,
                    textColor: '#000000'
                }
            },
            {
                content: `${this.abrechnung.tagegeldersumme()} €`,
                styles: {
                    halign: 'right',
                    valign: 'middle',
                    fontStyle: 'bold',
                    fontSize: 10,
                    fillColor: false,
                    lineColor: false,
                    textColor: '#000000'
                }
            }
        ])
        kostenData.push(
            [
                { content: 'Fahrtkosten:', colSpan: 3, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#dddddd', textColor: '#000000' } },
            ]
        );
        if (this.abrechnung.fahrtkosten.opnv.active && this.abrechnung.fahrtkosten.opnv.summe > 0) {
            kostenData.push(
                [
                    { content: this.abrechnung.fahrtkosten.opnv.active ? `ÖPNV (lt. Beleg)` : '', colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${this.abrechnung.fahrtkosten.opnv.active ? this.abrechnung.fahrtkosten.opnv.summe + ' €' : ''}`, styles: { cellWidth: 30, halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                ]
            );
        }
        if (this.abrechnung.fahrtkosten.pkw.active && this.abrechnung.fahrtkosten.pkw.summe > 0) {
            kostenData.push(
                [
                    { content: `PKW ${this.abrechnung.fahrtkosten.pkw.active ? `Kennzeichen: ${this.abrechnung.fahrtkosten.pkw.kennzeichen} - ${this.abrechnung.fahrtkosten.pkw.kilometer}km je 0.30€` : ''}`, colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${this.abrechnung.fahrtkosten.pkw.active ? this.abrechnung.fahrtkosten.pkw.summe + ' €' : ''}`, styles: { cellWidth: 30, halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                ]
            );
        }
        if (this.abrechnung.fahrtkosten.taxi.active && this.abrechnung.fahrtkosten.taxi.summe > 0) {
            kostenData.push(
                [
                    { content: `Taxi (lt. Beleg)`, colSpan: 2, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                    { content: `${this.abrechnung.fahrtkosten.taxi.active ? this.abrechnung.fahrtkosten.taxi.summe + ' €' : ''}`, styles: { cellWidth: 30, halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#ffffff', textColor: '#000000' } },
                ]
            );
        }

        kostenData.push([
            {
                content: `Summe:`,
                colSpan: 2,
                styles: {
                    halign: 'right',
                    valign: 'middle',
                    fontStyle: 'bold',
                    fontSize: 10,
                    fillColor: false,
                    lineColor: false,
                    textColor: '#000000'
                }
            },
            {
                content: `${this.abrechnung.fahrtkostensumme()} €`,
                styles: {
                    halign: 'right',
                    valign: 'middle',
                    fontStyle: 'bold',
                    fontSize: 10,
                    fillColor: false,
                    lineColor: false,
                    textColor: '#000000'
                }
            }
        ])


        autoTable(this.doc, {
            startY: this.pos.y,
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
            },
            tableWidth: 'auto',
            head: [], // Header row
            body: kostenData,
            didDrawPage: (data) => {
                this.pos.y = parseInt(data.cursor.y);
            }
        });

        const ausgabenData = []

        const ausgabenHead = []

        if (this.abrechnung.ausgaben.length > 0) {
            this.pos.y += 10

            // Ausgaben Details grouped by Kostenarten
            ausgabenHead.push(
                [
                    { content: `Ausgaben`, colSpan: 4, styles: { halign: 'center', valign: 'middle', cellPadding: 3, fontStyle: 'bold', fontSize: 12, fillColor: '#ffffff', lineColor: '#ffffff', textColor: '#000000' } }

                ],
                [
                    { content: `Datum`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#dddddd', textColor: '#000000' } },
                    { content: `Kostenart`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#dddddd', textColor: '#000000' } },
                    { content: `Beschreibung`, styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fillColor: '#dddddd', textColor: '#000000' } },
                    { content: `Kosten`, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#dddddd', textColor: '#000000' } },
                ],
            )



            this.abrechnung.ausgaben.forEach(kosten => {
                const kostenart = this.kostenarten.find(k => k.id == kosten.kostenart)
                ausgabenData.push([
                    {
                        content: this.abrechnung.parseDatum(kosten.datum),
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            fontStyle: 'normal',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: kostenart.name,
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            fontStyle: 'bold',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: `${kosten.name} ${kosten.lerneinheiten ? '(' + kosten.lerneinheiten + ' LE)' : ''}`,
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            fontStyle: 'normal',
                            textColor: '#000000'
                        }
                    },
                    {
                        content: `${kosten.kosten} €`,
                        styles: {
                            halign: 'right',
                            valign: 'middle',
                            fontStyle: 'bold',
                            textColor: '#000000'
                        }
                    }
                ])
            })
            ausgabenData.push([
                {
                    content: `Summe:`,
                    colSpan: 3,
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        fontSize: 10,
                        fillColor: false,
                        lineColor: false,
                        textColor: '#000000'
                    }
                },
                {
                    content: `${this.abrechnung.ausgabensumme()} €`,
                    styles: {
                        halign: 'right',
                        valign: 'middle',
                        fontStyle: 'bold',
                        fontSize: 10,
                        fillColor: false,
                        lineColor: false,
                        textColor: '#000000'
                    }
                }
            ])
        }

        ausgabenData.push(
            [
                { content: 'Gesamtsumme:', colSpan: 3, styles: { halign: 'right', valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } },
                { content: `${this.abrechnung.gesamtsumme() + ' €'}`, styles: { halign: 'right', cellWidth: 30, valign: 'middle', fontStyle: 'bold', fillColor: '#d91622', lineColor: '#d91622', textColor: '#ffffff' } }
            ]
        );

        autoTable(this.doc, {
            startY: this.pos.y,
            styles: {
                lineWidth: 0.5,
                lineColor: '#ccc',
            },
            tableWidth: 'auto',
            head: ausgabenHead,
            body: ausgabenData,
            didDrawPage: (data) => {
                this.finishTablePage(data, 5);
            }
        });

        this.checkPageBreak(200)

        this.printSignatures();

        this.printBelege();

    }

    reisekosten_wegpunkte() {
        if (this.abrechnung.wegpunkte?.length > 1) {
            var str = ''
            for (var i = 1; i <= this.abrechnung.wegpunkte.length - 1; i++) {
                if (i > 1) {
                    str += '\n'
                }
                str += 'Ziel ' + i + ': ' + this.abrechnung.wegpunkte[i].getString()
            }
            return str
        }
        else {
            return ''
        }
    }

    autoHeightImage(img, imgType, x, y, width) {
        // DIN A4 Seitenhöhe: 297mm, abzüglich Ränder und bereits verwendeter Höhe
        const maxPageHeight = 297;
        const availableHeight = maxPageHeight - y - 20; // 20mm Rand unten

        var imageHeight = 297 * width / 210;

        if (!imgType) {
            imgType = "JPEG"
        }

        const imgProps = this.doc.getImageProperties(img)
        if (imgProps) {
            imageHeight = (imgProps.height * width) / imgProps.width;
        }

        // Begrenze die Bildhöhe auf die verfügbare Seitenhöhe
        if (imageHeight > availableHeight) {
            imageHeight = availableHeight;
            // Berechne die entsprechend angepasste Breite
            if (imgProps) {
                width = (imgProps.width * imageHeight) / imgProps.height;
            }
        }

        this.doc.addImage(img, imgType, x, y, width, imageHeight, '', 'FAST');

        return imageHeight;
    }

    autoWidthImage(img, imgType, x, y, height, maxWidth) {
        const imgProps = this.doc.getImageProperties(img)

        var imageWidth = (imgProps.width * height) / imgProps.height;
        if (maxWidth && maxWidth < imageWidth) {
            this.autoWidthImage(img, imgType, x, y, height - 1, maxWidth)
        }
        else {
            this.doc.addImage(img, imgType, x, y, imageWidth, height, '', 'FAST');
        }
    }

    checkPageBreak(height) {
        if (this.pos.y > height) {
            this.doc.addPage();
            this.PageNumber++;
            this.PageCount++;
            this.doc.addImage(flvwLogo, "PNG", 15, 10, 15, 15, "FLVW Logo", "NONE", 0);
            this.pos.y = 15;
            this.doc.setFontSize(10);
            this.doc.setFont("helvetica", "normal", "normal");
            this.doc.text(`Seite ${this.PageCount} - ${this.abrechnung.abrechnender.vorname} ${this.abrechnung.abrechnender.nachname}`, 32, this.pos.y);
            this.pos.y += 4;
            this.doc.setFontSize(12);
            this.doc.setFont("helvetica", "normal", "bold");
            this.doc.text(this.abrechnung.type, 32, this.pos.y);
            this.doc.setFontSize(10);
            this.doc.setFont("helvetica", "normal", "normal");
            this.pos.y += 4;
            this.doc.text(this.abrechnung.zeitraum?.value?.name ?? '', 32, this.pos.y);
            this.pos.y += 10;
        }
    }

    pageBreakTable() {
        this.PageNumber++;
        this.PageCount++;
        this.pos.y = 15;
        this.doc.setFontSize(10);
        this.doc.setFont("helvetica", "normal", "normal");
        this.doc.text(`Seite ${this.PageCount} - ${this.abrechnung.type}\n${this.abrechnung.zeitraum.value.name} - ${this.person.vorname} ${this.person.nachname}`, 15, this.pos.y);
        this.pos.y += 10;
    }

    finishTablePage(data, spacing = 10) {
        if (data.pageNumber > 1) {
            this.pageBreakTable();
        }

        this.PageNumber = this.doc.getNumberOfPages();
        this.pos.y = parseInt(data.cursor.y) + spacing;
    }

    printSignatures() {
        this.checkPageBreak(297 - 60);

        this.doc.setFontSize(10);
        this.doc.setFont("helvetica", "normal", "bold");

        var x = 15;
        var y = this.pos.y;
        var height = 20;

        const eingereicht = this.abrechnung.freigaben.find(item => item.message.includes('Eingereicht'))
        if (eingereicht) {
            if (eingereicht?.user?.signatur) {
                this.autoWidthImage(eingereicht.user.signatur, 'PNG', x, y, 20, 80);
            }
            this.doc.line(x, y + height, x + 80, y + height);
            this.doc.text(`Eingereicht am ${this.abrechnung.parseTimestampDatum(eingereicht.timestamp)}\nvon ${eingereicht.user.name}`, x, y + height + 5);
        }
        else {
            this.doc.line(x, y + height, x + 80, y + height);
            this.doc.text(`Eingereicht`, x, y + height + 5);
        }
        x = 100

        const freigegeben = this.abrechnung.freigaben.find(item => item.message.includes('Freigegeben'))
        if (freigegeben) {
            if (freigegeben?.user?.signatur) {
                this.autoWidthImage(freigegeben.user.signatur, 'PNG', x, y, 20, 80);
            }
            this.doc.line(x, y + height, x + 80, y + height);
            this.doc.text(`Freigegeben am ${this.abrechnung.parseTimestampDatum(freigegeben.timestamp)}\nvon ${freigegeben.user.name}`, x, y + height + 5);
            y = y + height + 10
            x = 15
        }

        const genehmigt = this.abrechnung.freigaben.find(item => item.message.includes('Genehmigt'))
        if (genehmigt) {
            if (genehmigt?.user?.signatur) {
                this.autoWidthImage(genehmigt.user.signatur, 'PNG', x, y, 20, 80);
            }
            this.doc.line(x, y + height, x + 80, y + height);
            this.doc.text(`Genehmigt am ${this.abrechnung.parseTimestampDatum(genehmigt.timestamp)}\nvon ${genehmigt.user.name}`, x, y + height + 5);
        }
        else {
            this.doc.line(x, y + height, x + 80, y + height);
            this.doc.text(`Genehmigt`, x, y + height + 5);
        }
        y = x == 100 ? y + height + 10 : y
        x = x == 15 ? 100 : 15

        const abgeschlossen = this.abrechnung.freigaben.find(item => item.message.includes('abgeschlossen'))
        if (abgeschlossen) {
            if (abgeschlossen?.user?.signatur) {
                this.autoWidthImage(abgeschlossen.user.signatur, 'PNG', x, y, 20, 80);
            }
            this.doc.line(x, y + height, x + 80, y + height);
            this.doc.text(`Abgeschlossen am ${this.abrechnung.parseTimestampDatum(abgeschlossen.timestamp)}\nvon ${abgeschlossen.user.name}`, x, y + height + 5);
        }
        else {
            this.doc.line(x, y + height, x + 80, y + height);
            this.doc.text(`Abgeschlossen`, x, y + height + 5);
        }
    }

    printBelege() {
        /**
         * Belege anhängen
         */
        this.pdfBelege = []

        const belege = []
        if (this.abrechnung.v2) {
            this.abrechnung.ausgaben.forEach(ausgabe => {
                if (ausgabe.belege && ausgabe.belege.length > 0) {
                    ausgabe.belege.forEach(beleg => {
                        belege.push(beleg)
                    })
                }
            })
            if (this.abrechnung instanceof Reisekostenabrechnung) {
                if (this.abrechnung.fahrtkosten.opnv.active && this.abrechnung.fahrtkosten.opnv.belege && this.abrechnung.fahrtkosten.opnv.belege.length > 0) {
                    this.abrechnung.fahrtkosten.opnv.belege.forEach(beleg => {
                        belege.push(beleg)
                    })
                }
                if (this.abrechnung.fahrtkosten.taxi.active && this.abrechnung.fahrtkosten.taxi.belege && this.abrechnung.fahrtkosten.taxi.belege.length > 0) {
                    this.abrechnung.fahrtkosten.taxi.belege.forEach(beleg => {
                        belege.push(beleg)
                    })
                }
            }
        }
        else {
            this.abrechnung.belege.forEach(beleg => {
                if (beleg.dataurl || beleg.url) {
                    belege.push(beleg)
                }
            })
        }

        belege.forEach((beleg, index) => {
            const imageType = []
            imageType['image/jpeg'] = 'JPEG'
            imageType['image/jpg'] = 'JPEG'
            imageType['image/png'] = 'PNG'


            if (beleg.dataurl && !beleg.fileDoesNotExist) {
                try {

                    this.doc.addPage();

                    var imageWidth = this.doc.internal.pageSize.getWidth() - 20;

                    // Set the position where you want to add the image (x, y)
                    var x = 10;
                    var y = 15;

                    // Header
                    this.doc.addImage(flvwLogo, "PNG", 15, 10, 15, 15, "FLVW Logo", "NONE", 0);

                    this.doc.setFontSize(12);
                    this.doc.setFont("helvetica", "normal", "bold");
                    this.doc.text(`${this.abrechnung.type}`, 32, y);
                    this.doc.setFontSize(10);
                    this.doc.setFont("helvetica", "normal", "normal");
                    y += 4;
                    if (this.abrechnung.type == 'Reisekostenabrechnung') {
                        this.doc.text(`${this.abrechnung.reisezweck}`, 32, y);
                    } else {
                        this.doc.text(`${this.abrechnung.zeitraum?.value?.name}`, 32, y);
                    }
                    y += 4;
                    this.doc.setFontSize(10);
                    this.doc.setFont("helvetica", "normal", "normal");
                    this.doc.text(`Anhang ${index + 1}: ${beleg?.name}`, 32, y);
                    y += 4;
                    this.doc.text(`${beleg.beschreibung}`, 32, y);
                    y += 4;

                    // Add the image to the PDF
                    this.autoHeightImage(beleg.dataurl, imageType[beleg.type], x, y, imageWidth);
                } catch (error) {
                    console.error(error)
                }
            }
            else if (!beleg.fileDoesNotExist) {
                this.pdfBelege.push(beleg.url)
            }
        })
    }

    getRouteString(fahrt) {
        const person = this.abrechnung.abrechnender

        if (fahrt.route.type == 'Wegpunkte') {
            var str = ''

            fahrt.route.wegpunkte.forEach((point, index) => {
                if (index > 0) {
                    str += '\n'
                }
                if (point.equal(person.adresse)) {
                    str += `Start: Zuhause`
                }
                else if (index == fahrt.route.wegpunkte.length - 1) {
                    str += `Ziel: ${point.getString()}`
                }
                else {
                    str += `via: ${point.getString()}`
                }
            })
            str += `\nStrecke: ${fahrt.route.kilometer.value} km`

            return str
        }
        else {
            if (fahrt.route.start.equal(person.adresse)) {
                return `Start: Zuhause\nZiel: ${fahrt.route.ziel.getString()}\nStrecke: ${fahrt.route.kilometer.value} km`
            }
            else {
                return `Start: ${fahrt.route.start.getString()}\nZiel: ${fahrt.route.ziel.getString()}\nStrecke: ${fahrt.route.kilometer.value} km`
            }
        }
    }

    parseDate(datestring) {
        if (datestring instanceof String || typeof datestring === 'string') {
            const datum = datestring.split('-')
            return datum[2] + '.' + datum[1] + '.' + datum[0]
        }
        return ''
    }
}
